export const defaultBannerText = {
    title: 'Cookies Consent',
    description:
        'Splash uses cookies to keep the site working properly and securely. Some cookies are essential, while others help improve content, analyze usage, and personalize your experience. By clicking “Allow all,” you consent to Splash’s use of cookies.',
    chooseConsentSettings: 'Manage consent settings',
    declineNonEssentialButton: 'Decline non-essential',
    acceptAllButton: 'Accept all',
    confirmSelectionButton: 'Confirm choices',
    necessaryHeader: 'Strictly necessary',
    necessaryDescription: 'Required for basic site functionality',
    performanceHeader: 'Performance',
    performanceDescription:
        'Measure and improve the performance of the site by helping to provide a better user experience by tracking which pages are visited most often.',
    functionalityHeader: 'Functionality',
    functionalityDescription: 'Help us understand how visitors interact with our website',
    marketingHeader: 'Marketing',
    marketingDescription: 'Used to deliver personalized advertisements',
};

export const CVENT_LINKS = {
    PRIVACY_POLICY: 'https://www.cvent.com/en/cvent-global-privacy-policy',
    COOKIE_POLICY: 'https://www.cvent.com/en/appcookies',
};

export const defaultCookieLinks = {
    splashPrivacyPolicy: {
        text: 'Splash Privacy Policy',
        url: CVENT_LINKS.PRIVACY_POLICY,
    },
    splashCookieList: {
        text: 'Splash Cookie List',
        url: CVENT_LINKS.COOKIE_POLICY,
    },
};

export const COOKIE_CONSENT_STORAGE_KEY_PREFIX = 'splash_cookie_consent-';
